export default "__VITE_ASSET__DuELmSBj__"